import { createSvg } from '../createSvg';
var TV = function () {
    return <>
        <g id={'contour'}>
        <path fillRule='evenodd' clipRule='evenodd' d='M2.77445 7.08305C2.96012 5.32836 4.38624 4 6.08439 4H17.9156C19.6138 4 21.0399 5.32836 21.2255 7.08305L22.1046
            15.3907C22.3215 17.44 20.7779 19.2308 18.7947 19.2308H15.1439L15.5879 20.6154H16.4399C16.8077 20.6154 17.1059 20.9253
            17.1059 21.3077C17.1059 21.69 16.8077 22 16.4399 22H7.56012C7.19231 22 6.89414 21.69 6.89414 21.3077C6.89414 20.9253
            7.19231 20.6154 7.56012 20.6154H8.41207L8.85606 19.2308H5.2053C3.22209 19.2308 1.67851 17.44 1.89535 15.3907L2.77445
            7.08305ZM9.79543 17.8462C9.78509 17.8459 9.77478 17.8459 9.7645 17.8462H5.2053C4.01537 17.8462 3.08922 16.7717 3.21933
            15.5421L4.09843 7.23445C4.20983 6.18163 5.0655 5.38462 6.08439 5.38462H17.9156C18.9345 5.38462 19.7902 6.18163 19.9016 7.23445L20.7807
            15.5421C20.9108 16.7717 19.9846 17.8462 18.7947 17.8462H14.2355C14.2252 17.8459 14.2149 17.8459 14.2046 17.8462H9.79543ZM10.2601 19.2308L9.81608
            20.6154H14.1839L13.7399 19.2308H10.2601Z'/>
        </g>
    </>;
};
export default createSvg(TV, 'TV');
